/*=========================================================================================
  File Name: state.js
  Description: Vuex Store - state
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

///////////////////////////////////////////////
// State
///////////////////////////////////////////////

const state = {
  loading: false,
  confirmReload: false,
  breadcrumbs: [],
  screen: 'mobile',
}

export default state
